import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { Award, Users, TrendingUp, HeartHandshake } from 'lucide-react';
export function WhyROIPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const reasons = [{
    icon: Award,
    title: 'Built by Operators',
    description: "We're not just software engineers. We've managed kitchens, run front-of-house, and balanced restaurant books for decades."
  }, {
    icon: Users,
    title: 'Unmatched Support',
    description: "Our support team speaks your language. We're available when you are—including late nights and weekends."
  }, {
    icon: TrendingUp,
    title: 'Proven ROI',
    description: 'Our clients see an average of 3-5% increase in net profit margins within the first 90 days of implementation.'
  }, {
    icon: HeartHandshake,
    title: 'No Hidden Fees',
    description: 'Transparent pricing with no implementation fees, no per-user charges, and no long-term lock-in contracts.'
  }];
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-stark-white" data-id="element-384">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-385" />

      <section className="pt-32 pb-20 bg-midnight-navy text-stark-white" data-id="element-386">
        <div className="max-w-7xl mx-auto px-6" data-id="element-387">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-388">
            <h1 className="text-5xl md:text-6xl font-manrope font-bold mb-6" data-id="element-389">
              Why ROI?
            </h1>
            <p className="text-xl text-stark-white/70 leading-relaxed" data-id="element-390">
              In an industry where every penny counts, you need a partner that
              understands the stakes.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24" data-id="element-391">
        <div className="max-w-7xl mx-auto px-6" data-id="element-392">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-393">
            {reasons.map((reason, idx) => <motion.div key={reason.title} initial={{
            opacity: 0,
            x: idx % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex gap-6" data-id="element-394">
                <div className="shrink-0 w-16 h-16 bg-midnight-navy text-stark-white rounded-xl flex items-center justify-center" data-id="element-395">
                  <reason.icon className="w-8 h-8" data-id="element-396" />
                </div>
                <div className="space-y-3" data-id="element-397">
                  <h3 className="text-2xl font-manrope font-bold text-midnight-navy" data-id="element-398">
                    {reason.title}
                  </h3>
                  <p className="text-lg text-midnight-navy/60 leading-relaxed" data-id="element-399">
                    {reason.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-cool-gray" data-id="element-400">
        <div className="max-w-7xl mx-auto px-6 text-center space-y-12" data-id="element-401">
          <h2 className="text-4xl font-manrope font-bold text-midnight-navy" data-id="element-402">
            Trusted by the Best
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12" data-id="element-403">
            {[{
            name: 'The Daily Grill',
            logo: 'https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png'
          }, {
            name: 'Urban Eats',
            logo: 'https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png'
          }, {
            name: 'Coastal Kitchen',
            logo: 'https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png'
          }, {
            name: 'Metro Bistro',
            logo: 'https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png'
          }].map((partner, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex flex-col items-center gap-4 group" data-id="element-404">
                <div className="h-20 w-full bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center p-4 grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-405">
                  <img src={partner.logo} alt={partner.name} className="h-full w-auto object-contain opacity-40 group-hover:opacity-100 transition-opacity" data-id="element-406" />
                </div>
                <span className="text-midnight-navy/40 font-bold text-xs uppercase tracking-widest group-hover:text-accent-red transition-colors" data-id="element-407">
                  {partner.name}
                </span>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-408" />
      <Footer data-id="element-409" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-410" />
    </motion.main>;
}